import props from './attrs/props'

export default {
  name: 'ListHeader',
  props
}
